define('view/controller/booking/datetime/DateTimeStepInlineLayout',['require','view/controller/booking/datetime/DateTimeStepDefaultLayout'],function (require) {

	var DateTimeStepDefaultLayout = require('view/controller/booking/datetime/DateTimeStepDefaultLayout');
	
	/**
	 * Datetime step layout with inline date navigation
	 * 
	 * @class DateTimeStepInlineLayout
	 */
	return DateTimeStepDefaultLayout.extend({
	
	    template: '#datetime_step_inline_layout',

        supportsTimelineNavigation: function () {
            return false;
        }
	    
	});

});
